export const TRAIN_STATES = {
  ACTIVE: "active",
  PENDING: "pending",

  SYNC: "sync",
  SYNC_FINISHED: "sync_finished",

  SERVER_MANAGER: "server_manager",
  SERVER_MANAGER_FINISHED: "server_manager_finished",

  TRAIN: "train",
  TRAIN_FINISHED: "train_finished",

  ERROR_CATCHER: "error_catcher",
  ERROR_CATCHER_FINISHED: "error_catcher_finished",

  TRANSFER_MANAGER: "transfer_manager",
  TRANSFER_MANAGER_FINISHED: "transfer_manager_finished",

  REBOOT: "reboot",

  DRAFT_MODELS: "draft_models",
  DRAFT_MODELS_FINISHED: "draft_models_finished",

  ERROR: [
    "error",
    "sync_error",
    "server_manager_error",
    "train_error",
    "error_catcher_error",
    "transfer_manager_error",
    "draft_models_error",
    "maintenance",
  ],
  MAINTENANCE: "maintenance",
};
